import { atom } from 'jotai';

/**
 * Jotai atom to store the payment popup open state.
 * This allows sharing the popup state across different components
 * without prop drilling.
 */
export const paymentPopupOpenAtom = atom<boolean>(false);

/**
 * Jotai atom to store the current invoice URL segment for payment.
 * This allows sharing the URL segment across different components
 * without prop drilling.
 */
export const paymentPopupUrlSegmentAtom = atom<string>('');

/**
 * Jotai atom to store the Stripe account for payment.
 * This allows sharing the Stripe account across different components
 * without prop drilling.
 */
export const paymentPopupStripeAccountAtom = atom<string | null>(null);

/**
 * Jotai atom to store the invoice payment ID for payment.
 * This allows sharing the payment ID across different components
 * without prop drilling.
 */
export const paymentPopupPaymentIdAtom = atom<number>(0);

/**
 * Jotai atom to store the Stripe publishable key for payment.
 * This allows the popup to use the correct publishable key for
 * the invoice's Stripe account configuration.
 */
export const paymentPopupPublishableKeyAtom = atom<string | null>(null);

/**
 * Jotai atom to store the instalment amount the proposal page was rendered with, before surcharge.
 * Sent with the payment intent request so the server can refuse a page that is quoting an amount the
 * invoice no longer has.
 */
export const paymentPopupDisplayedAmountAtom = atom<number | null>(null);
